import React from "react";
import JoditEditor from "jodit-react";

export default function SpecialisationForm(props) {
    const editorConfig = {
        readonly: false,
        height: 200
    };
    return <>
        <div id={`${
            typeof props.id !== "undefined" ? props.id : "responsive-modal"
        }`} className="modal fade bs-example-modal-lg" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" style={{display: 'none'}}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title" id="myLargeModalLabel">{props.title ?? ""}</h4>
                        <button type="button" className={`${
                            typeof props.close !== "undefined" ? props.close : "close"
                        }`}  id={`${
                            typeof props.close !== "undefined" ? props.close : "close"
                        }`} data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Specialisation Name</label>
                                <input
                                    name="specialisationName"
                                    className="form-control"
                                    id="specialisationName"
                                    value={props.formData.specialisationName}
                                    onChange={props.onEdit}
                                    placeholder="Specialisation Name"
                                />

                            </div>
                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Consultation Fee</label>
                                <input
                                    type="number"
                                    name="consultationFee"
                                    className="form-control"
                                    id="consultationFee"
                                    value={props.formData.consultationFee}
                                    onChange={props.onEdit}
                                    placeholder="Consultation Fee"
                                />

                            </div>
                            <div className="mb-3 col-md-12 form-group">
                                <label className="form-label">Description </label>
                                <JoditEditor
                                    value={props.formData.specialisationDescription}
                                    config={editorConfig}
                                    onBlur={props.descriptionHandler}
                                    onChange={(newContent) => {
                                    }}
                                />
                            </div>

                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default waves-effect" data-dismiss="modal">Close
                        </button>
                        {
                            props.IsFormLoading ?
                                <button type="button" className="btn btn-primary ms-auto">
                                    <span><span className="spinner-border spinner-border-sm me-2" role="status"/> Please wait...</span>
                                </button>
                                :
                                <button type="button" onClick={props.onSubmit}
                                        className="btn btn-danger waves-effect waves-light">{props.btn ?? "submit"}</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
}